import { FormBase } from 'core/components';

export const importItemFormProperties = {
    fields: [
        {
            name: 'productId',
            label: 'IMPORT_PATIENT.ITEM.PRODUCT_LABEL',
            placeholder: 'IMPORT_PATIENT.ITEM.PRODUCT_PLACEHOLDER',
            rules: 'string'           
        },
        {
            name: 'quantity',
            label: 'IMPORT_PATIENT.ITEM.QUANTITY_LABEL',
            placeholder: 'IMPORT_PATIENT.ITEM.QUANTITY_PLACEHOLDER'
        }
    ]
};
export default class InsuranceForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return importItemFormProperties;
    }
}
